import React from "react";
import "../../../css/buttons/TertiaryButton.css";

const TertiaryButton = ({ onClick, text }) => {
  const handleClick =
    onClick ||
    (() => {
      const label = text?.toLowerCase() || "";

      if (label.includes("read faqs")) {
        document
          .querySelector("#faqs, [data-section='faqs']")
          ?.scrollIntoView({ behavior: "smooth" });
      }
    });

  return (
    <button type="button" className="tertiary-button" onClick={handleClick}>
      <div className="button-text ">{text}</div>
    </button>
  );
};

export default TertiaryButton;
